import { SidebarProvider } from '@/components/ui/sidebar';
import { AppSidebar } from './AppSidebar';
import { useIsMobile } from '@/hooks/utilities/use-mobile';
import Navbar from './Navbar';
export default function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  const isMobile = useIsMobile();

  //TODO refactor probably very inefficent
  if (isMobile) return <main>{children}</main>;
  return <SidebarProvider data-sentry-element="SidebarProvider" data-sentry-component="Layout" data-sentry-source-file="Layout.tsx">
      <AppSidebar data-sentry-element="AppSidebar" data-sentry-source-file="Layout.tsx" />
      <main className='w-[85%]'>
        <Navbar data-sentry-element="Navbar" data-sentry-source-file="Layout.tsx" />
        <div className='h-[91vh] desktop-background'>{children}</div>
      </main>
    </SidebarProvider>;
}